<script lang="ts">import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const OriginalsIcon = getIcon("OriginalsIcon");
</script>

{#if typeof OriginalsIcon === 'string'}
	<img src={OriginalsIcon} alt={$t(Verbiage.originals_icon_alt, 'alts')} />
{:else if typeof OriginalsIcon === 'function'}
	<svelte:component this={OriginalsIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
